import AppoinmentPasien from "../../components/AppoinmentPasien/AppoinmentPasienOnline";

export default function Appoinment() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AppoinmentPasien/>
    </div>
  );
}
